<template>
  <div class="DetailContent flex flex-col w-full justify-between h-full">
    <div class="main-detail">
      <div class="SubscriptionPlan flex flex-col md:flex-row md:items-center mb-3 pt-2" v-if="dataType === 'PLAN' && purchasePenData.category_id">
        <div class="magazineLogo md:mr-2 flex justify-center md:justify-start w-auto md:w-40">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_abc.png" alt="livaABC" v-if="purchasePenData.category_id === 123">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_live.png" alt="livaABC" v-if="purchasePenData.category_id === 124">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_all.png" alt="livaABC" v-if="purchasePenData.category_id === 125">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_cnn.png" alt="livaABC" v-if="purchasePenData.category_id === 126">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_jp.png" alt="livaABC" v-if="purchasePenData.category_id === 122">
          <img class="w-full h-full object-contain" src="~@/assets/logo/logo_hiw.png" alt="livaABC" v-if="purchasePenData.category_id === 121">
        </div>
        <div class="flex flex-wrap justify-center md:justify-start">
          <h4 class="m-0 text-2xl text-center md:text-left text-NotoSansBold">{{ purchasePenData.edition }}&nbsp;</h4>
          <h4 class="m-0 text-2xl text-center md:text-left text-NotoSansBold">訂閱方案</h4>
        </div>
      </div>

      <div class="px-2 md:px-0">
        <div class="SubscriptionPlan flex items-center mb-2" v-if="dataType !== 'PLAN'">
          <h1 class="m-0 text-xl lg:text-2xl text-NotoSansBold font-bold tracking-wider">{{ purchasePenData.name }}</h1>
        </div>
        <div class="SubscriptionDetail">
          <div class="activity flex mt-1 mb-2 border-l-2 borderOrange flex-col" v-if="(all_events || purchasePenData.event) && purchasePenData.status !== 'DISCONTINUED'">
            <!-- 絕版不顯示 -->
            <ul v-if="all_events && purchasePenData.event && purchasePenData.event.is_exclude === 0" class="ml-2">
              <li v-for="(item, index) in all_events" :key="index" class="flex textColorRed text-NotoSansLight">
                <router-link :to="{ name: 'sale', params: { category: $route.params.category }, query: { tag: item.id } }" class="flex">
                  <p class="m-0 font-normal text-sm"><span>全館‧</span>{{ item.name }}</p>
                </router-link>
              </li>
            </ul>
            <ul v-if="purchasePenData.event" class="ml-2">
              <li class="flex textColorRed text-NotoSansLight">
                <router-link :to="{ name: 'sale', params: { category: $route.params.category }, query: { tag: purchasePenData.event.id } }" class="flex">
                  <p class="m-0 font-normal text-sm"><span>商品‧</span>{{ purchasePenData.event.name }}</p>
                </router-link>
              </li>
            </ul>
          </div>
          <h5 class="category font-normal text-NotoSansRegular mt-3" v-if="dataType !== 'PLAN' && purchasePenData.category_name">類別：
            <span>{{ purchasePenData.category_name }}</span>
          </h5>
          <h5 class="contents font-normal text-NotoSansRegular flex" v-if="purchasePenData.contents">
            <span class="whitespace-no-wrap">內容：</span>
            <span>{{ purchasePenData.contents }}</span>
          </h5>
          <!-- <h5 v-if="dataType === 'PLAN'" class="leading-normal border p-2 textColorRed borderRed">
            自111年10月號起，訂閱或購買英日語雜誌將不再附贈朗讀CD光碟片，可使用『QR-CODE網站』或『至官網下載』等更便利的方式聆聽MP3。
            <mark class="warning">響應環保的你，若不需要朗讀CD光碟片，請在訂單「備註事項」說明讓我們知道喔！</mark>
            </h5> -->
          <h5 class="specification font-normal text-NotoSansRegular" v-if="purchasePenData.specification">規格：
            <span>{{ purchasePenData.specification }}</span>
          </h5>
          <h5 class="ISBN font-normal text-NotoSansRegular" v-if="isISBN && (dataType === 'ITEM' || dataType === 'BOOK') && purchasePenData.ISBN">ISBN：
            <span>{{ purchasePenData.ISBN }}</span>
          </h5>
          <div class="periods flex flex-nowrap text-NotoSansRegular my-2" v-if="dataType === 'PLAN' && purchasePenData.plan && purchasePenData.plan.length > 0">
            <h5 class="whitespace-no-wrap">期數：</h5>
            <div class="w-full px-3 md:px-0">
              <div class="relative">
                <select v-model="selectedPlan" @change="getEndTime" class="text-sm block appearance-none w-full border border-gray-500 text-gray-700 py-2 px-8 pr-12 rounded leading-tight focus:outline-none bg-white focus:border-gray-500"
                  id="selected-period">
                  <option :value="item" v-for="(item, index) in purchasePenData.plan" :key="index">{{ item.name }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
          </div>
          <div class="startEndTime flex flex-nowrap text-NotoSansRegular my-2 md:mb-4" v-if="dataType === 'PLAN'">
            <h5 class="whitespace-no-wrap">起訖：</h5>
            <div class="peirod flex flex-no-wrap px-3 lg:px-0">
              <div class="startTime flex">
                <date-picker v-model="begin_at" valueType="format" type="month" placeholder="請選擇" @change="getEndTime" :disabled-date="disabledDate" :input-class="'input-class'"></date-picker>
              </div>
              <div class="flex items-center justify-center"  style="width: 8%;">
                <p class="">~</p>
              </div>
              <div class="endTime flex">
                <input v-model="end_at" readonly class="w-full appearance-none rounded px-2 focus:outline-none text-sm" id="grid-password" type="text" placeholder="">
              </div>
            </div>
          </div>
          <div v-if="dataType === 'PLAN' && !selectedPlan.is_digital" class="my-2">
            <div class="shiping flex flex-nowrap text-NotoSansRegular">
              <h5 class="whitespace-no-wrap">運送：</h5>
              <fieldset class="radio-switch text-center hidden md:block">
                <input type="radio" class="custom-radio-control show-for-sr" name="projectShipping" :value="false" id="project_ordinary" checked
                  v-model="isRegisteredMail">
                <label for="project_ordinary" class="px-3 py-1 xl:px-5">平信</label>

                <input type="radio" class="custom-radio-control show-for-sr" name="projectShipping" :value="true" id="project_registered" v-model="isRegisteredMail">
                <label for="project_registered" class="px-3 py-1 xl:px-5">掛號</label>
              </fieldset>
              <div class="items-center hidden md:flex ml-2">
                <p class="text-sm text-right">(掛號費每期20元)</p>
              </div>
              <div class="w-full md:w-48 px-3 md:hidden">
                <div class="relative">
                  <select v-model="isRegisteredMail" id="selected-shipping"
                    class="block appearance-none w-full border border-gray-500 text-gray-700 py-2 px-8 pr-12 rounded leading-tight focus:outline-none bg-white focus:border-gray-500 text-sm">
                    <option :value="false">平信</option>
                    <option :value="true">掛號</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
                </div>
              </div>
            </div>
            <p class="text-sm text-right px-3 md:hidden textColorRed">(掛號費每期20元)</p>
          </div>
          <div class="purshase flex flex-nowrap text-NotoSansRegular my-2"
            v-if="dataType === 'PLAN' && purchasePenData.livepen">
            <h5 class="whitespace-no-wrap md:hidden">${{ Number(purchasePenData.livepen.price) }}加購{{ purchasePenData.livepen.name }}：</h5>
            <h5 class="whitespace-no-wrap hidden md:block">{{ purchasePenData.livepen.name }}(加購價${{ Number(purchasePenData.livepen.price) }})：</h5>
            <fieldset class="radio-switch text-center hidden md:block">
              <input type="radio" class="custom-radio-control show-for-sr" name="projectPurshase" :value="true" id="isPurshasePen" checked
                v-model="subscriberStatus.isPurshasePen">
              <label for="isPurshasePen" class="px-3 py-1 xl:px-5">是</label>

              <input type="radio" class="custom-radio-control show-for-sr" name="projectPurshase" :value="false" id="notPurshasePen"
                v-model="subscriberStatus.isPurshasePen">
              <label for="notPurshasePen" class="px-3 py-1 xl:px-5">否</label>
            </fieldset>
            <div class="w-full px-2 sm:px-3 md:hidden">
              <div class="relative">
                <select v-model="subscriberStatus.isPurshasePen" id="project_PurshasePen"
                  class="block appearance-none w-full border border-gray-500 text-gray-700 py-2 px-2 rounded leading-tight focus:outline-none bg-white focus:border-gray-500 text-sm">
                  <option :value="true">是</option>
                  <option :value="false">否</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
          </div>
          <h5 class="published_at whitespace-no-wrap font-normal text-NotoSansRegular" v-if="dataType === 'BOOK' || dataType === 'MAGAZINE'">出版日期：
            <span>{{ moment(purchasePenData.published_at).format('YYYY/MM/DD') }}</span>
          </h5>
          <h5>
            <span v-if="dataType === 'MAGAZINE' || (dataType === 'PLAN' && selectedPlan)">售價：</span>
            <span v-if="isPrice && (dataType === 'BOOK' || dataType === 'PACKAGE' || dataType === 'ITEM')" class="originPrize">原價：</span>

            <span class="originPrize text-NotoSansRegular mr-1" v-if="isPrice && dataType !== 'PLAN'">{{ purchasePenData.fixed_price }}元</span>
            <span class="originPrize text-NotoSansRegular mr-1" v-if="isPrice && dataType === 'PLAN' && selectedPlan && subscriberStatus.isPurshasePen && purchasePenData.livepen">{{ selectedPlan.fixed_price + Number(purchasePenData.livepen.price) }}元</span>
            <span class="originPrize text-NotoSansRegular mr-1" v-if="isPrice && dataType === 'PLAN' && selectedPlan && !subscriberStatus.isPurshasePen">{{ selectedPlan.fixed_price }}元</span>
            <span class="mr-1 textColorRed font-semibold text-NotoSansBold" v-if="isPrice && dataType !== 'PLAN' && purchasePenData.display_discount">
              {{ purchasePenData.display_discount }}折</span>

            <span class="text-NotoSansRegular" v-if="isPrice && dataType !== 'PLAN' || (dataType === 'PLAN' && selectedPlan)">特價：</span>
            <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="isPrice && dataType !== 'PLAN'">{{ purchasePenData.pricing }}元</span>
            <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="isPrice && dataType === 'PLAN' && selectedPlan && subscriberStatus.isPurshasePen">{{ selectedPlan.pricing + Number(purchasePenData.livepen.price) }}元</span>
            <span class="newPrize text-NotoSansBold font-bold text-NotoSansBold" v-if="isPrice && dataType === 'PLAN' && selectedPlan && !subscriberStatus.isPurshasePen">{{ selectedPlan.pricing }}元</span>
          </h5>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable no-unused-expressions */
// import axios from 'axios'
export default {
  name: 'DetailContent',

  props: {
    purchasePenData: {
      type: Object
    },
    activityData: {
      type: Object
    },
    all_events: {
      type: Array
    },
    isISBN: {
      type: Boolean
    },
    isPrice: {
      type: Boolean
    }
  },

  data () {
    return {
      dataList: null,

      selectedPlan: '',

      // gift
      selectedGift: '',

      // 運送方式
      isRegisteredMail: false,

      // 起訖日期
      disabledDate (date) {
        // 當月不算，往後12個月，2024/4/30行銷部要求修改
        // 當月~當月+12，2025/12/31行銷部要求修改
        const now = new Date()
        // 當月第一天
        const start = new Date(now.getFullYear(), now.getMonth(), 1)

        // 當月 + 12 個月的最後一天
        const end = new Date(now.getFullYear(), now.getMonth() + 13, 0)

        return date < start || date > end
      },

      begin_at: null,
      end_at: null,

      downloadFiles: {
        lifePenFile: null,
        myVoiceFile: null,
        Mp3File: null,
        JLPTFile: null,
        uploadFile: null
      },

      // 驗證訂戶編號popup
      subscriberStatus: {
        isShow: false,
        isVerify: false,

        // 加購點讀筆
        isPurshasePen: false
      },

      // 限雜誌訂戶加購
      additionalForSubscribers: ['6743', '8848', '7944', '11175', '11174']
    }
  },
  computed: {
    dataType () {
      let self = this
      if (self.purchasePenData && self.purchasePenData !== null) {
        return self.purchasePenData.type
      } else {
        return null
      }
    }
  },
  watch: {
  },
  mounted () {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .main {
    .playerIcon {
      top: 50%;
      transform: translateY(-50%);
      ul {
        li {
          a {
            width: 90px;
            height: 90px;
          }
        }
      }
    }
    .cover {
      position: relative;
      width: 100%;
      padding-bottom : 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: white;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding-bottom : 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .square-img-none {
        background-image: url('~@/assets/images/preset_item.png');
      }
    }
    .SubscriptionPlan {
      .magazineLogo {
        img {
          max-width: 190px;
        }
      }
      h1 {
        color: #434343;
      }
    }
    .SubscriptionDetail {
      .startEndTime {
        .startTime {
          width: 46%;
        }
        .endTime {
          width: 46%;
        }
      }
      h5 {
        line-height: 2.2rem;
        font-size: 15px;
        @media (max-width: 769px) {
          line-height: 2rem;
        }
      }

      .radio-switch {
        input {
          position: absolute;
          visibility: hidden;
        }
        label {
          background-color: #ffffff;
          border-radius: 15px;
          border: 1px solid #e60012;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
          transition: background-color .2s ease;
          margin-right: .2em;
          margin-left: .2em;
          color: #434343;
          font-weight: 400;
          &:hover {
            background-color: #e60012;
            color: white;
            cursor: pointer;
          }
        }
        input:checked + label {
          background-color: #e60012;
          color: white;
        }
      }
      .label-grop {
        h5 {
          line-height: 1.5rem;
          font-size: 14px;
        }
      }
      .activity {
        h5, p {
          line-height: 1.5rem;
          font-size: 14px;
        }
      }
      .originPrize {
        text-decoration:line-through;
        color: #434343;
        font-size: 14px;
      }
      .newPrize {
        color: #e60012;
        font-size: 2em;
        font-weight: 700;
        @media (max-width: 769px) {
          font-size: 1.8em;
        }
      }

    }
    .buyBtn {
      .btn {
        color: #ffffff;
        font-size: 16px;
        padding: .5em 1.8em;
        border-radius: 5px;
        margin: 0 .4rem;
        @media (max-width: 1024px) {
          // font-size: 14px;
          padding: .6em 1.8em;
        }
      }
      .addCartBtn {
        background-color: #D80303;
        color: #ffffff;
      }
      .insBuyBtn {
        background-color: #219653;
        color: #ffffff;
      }
      .addWishBtn {
        background-color: #BDBDBD;
        color: #ffffff;
      }
      .cannotbuyBtn {
        background-color: #e5e5e5;
        color: #5d5d5d;
      }
      .chooseBtn {
        width: 120px;
        height: 38px;
        background-color: white;
        border: 1px solid #e60012;
        color: #e60012;
        font-size: 14px;
        margin: 0 .2rem;
        position: relative;
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
        }
        &:active {
          span {
            transform: translate(-50%, -45%);
          }
        }
      }
      .isFavorite {
        background-color: #e60012;
        color: white;
        cursor: default !important;
      }
    }
    .input-class {
      display: inline-block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      height: 38px;
      padding-left: 0.5rem;
      font-size: 14px;
      line-height: 1.4;
      color: #555;
      background-color: #fff;
      border: 1px solid #a0aec0;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    }
  }
</style>
